var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-wrapper"},[(_vm.cardData.videoUrl)?_c('video',{staticClass:"video-wrapper",style:({
      width: '100%',
      height: '100%',
      borderRadius: _vm.imageConfig.borderRadius ? _vm.arrToPx(_vm.imageConfig.borderRadius) : '',
      'object-fit': 'cover'
    }),attrs:{"src":_vm.cardData.videoUrl,"controls":false,"autoplay":"","loop":"","muted":"","poster":_vm.cardData.imageUrl},domProps:{"muted":true}}):_c('el-image',{staticClass:"image-wrapper--full-cover",style:({
      width: '100%',
      height: '100%',
      borderRadius: _vm.imageConfig.borderRadius ? _vm.arrToPx(_vm.imageConfig.borderRadius) : ''
    }),attrs:{"src":_vm.cardData.imageUrl,"fit":_vm.imageConfig.fit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }